import { serializePublicKeyToBase64 } from "@hyper-hyper-space/hhs3_mvt";
import { decodePublicKey } from "@hyper-hyper-space/hhs3_rdb_runtime";
export class DumpAliasContext {
    constructor(hints) {
        this.hints = hints;
        this.emitted = new Set();
        this.hashToName = new Map();
        this.usedNames = new Map();
        this.pending = [];
        this.versionCounters = new Map();
        this.counters = { key: 0, schema: 0, group: 0, db: 0 };
    }
    key(id, hint) { var _a, _b; return this.ensure('key', id, (_b = hint !== null && hint !== void 0 ? hint : (_a = this.hints.keyLabels) === null || _a === void 0 ? void 0 : _a.get(id)) !== null && _b !== void 0 ? _b : this.next('key')); }
    schema(id, hint) { var _a, _b; return this.ensure('schema', id, (_b = hint !== null && hint !== void 0 ? hint : (_a = this.hints.schemaNames) === null || _a === void 0 ? void 0 : _a.get(id)) !== null && _b !== void 0 ? _b : this.next('schema')); }
    group(id, hint) { var _a, _b; return this.ensure('group', id, (_b = hint !== null && hint !== void 0 ? hint : (_a = this.hints.groupNames) === null || _a === void 0 ? void 0 : _a.get(id)) !== null && _b !== void 0 ? _b : this.next('group')); }
    db(id, hint) { var _a, _b; return this.ensure('db', id, (_b = hint !== null && hint !== void 0 ? hint : (_a = this.hints.dbNames) === null || _a === void 0 ? void 0 : _a.get(id)) !== null && _b !== void 0 ? _b : this.next('db')); }
    version(hash, scope) {
        var _a;
        const existing = this.hashToName.get(`version:${hash}`);
        if (existing !== undefined)
            return existing;
        const n = ((_a = this.versionCounters.get(scope.objectId)) !== null && _a !== void 0 ? _a : 0) + 1;
        this.versionCounters.set(scope.objectId, n);
        const name = this.unique('version', `${scope.objectName}_ver${n}`);
        this.register('version', hash, name);
        return name;
    }
    drainDefinitions() {
        const result = [...this.pending];
        this.pending.length = 0;
        return result;
    }
    lookupKeyAlias(id) { return this.hashToName.get(`key:${id}`); }
    lookupPublicKeyAlias(serialized) {
        var _a;
        for (const [id, publicKey] of (_a = this.hints.keyPublicKeys) !== null && _a !== void 0 ? _a : []) {
            if (publicKey === serialized)
                return this.lookupKeyAlias(id);
        }
        return undefined;
    }
    ensure(scope, hash, preferred) {
        const existing = this.hashToName.get(`${scope}:${hash}`);
        if (existing !== undefined)
            return existing;
        const name = this.unique(scope, preferred);
        this.register(scope, hash, name);
        return name;
    }
    register(scope, hash, name) {
        this.hashToName.set(`${scope}:${hash}`, name);
        const key = `${scope}:${name}`;
        if (this.emitted.has(key))
            return;
        this.emitted.add(key);
        this.pending.push(`\\alias ${scope} ${name} #${hash}`);
    }
    unique(scope, preferred) {
        var _a;
        const names = (_a = this.usedNames.get(scope)) !== null && _a !== void 0 ? _a : new Set();
        this.usedNames.set(scope, names);
        if (!names.has(preferred)) {
            names.add(preferred);
            return preferred;
        }
        let i = 2;
        while (names.has(`${preferred}${i}`))
            i++;
        const name = `${preferred}${i}`;
        names.add(name);
        return name;
    }
    next(scope) {
        const number = ++this.counters[scope];
        return scope === 'key' ? `keyId${number}` : `${scope}${number}`;
    }
}
export function createDumpAliasContext(session) {
    var _a, _b;
    const hints = {
        keyLabels: new Map(), keyPublicKeys: new Map(), schemaNames: new Map(), groupNames: new Map(), dbNames: new Map(),
    };
    for (const key of (_b = (_a = session.keyVault) === null || _a === void 0 ? void 0 : _a.list()) !== null && _b !== void 0 ? _b : []) {
        hints.keyLabels.set(key.keyId, key.label);
        hints.keyPublicKeys.set(key.keyId, serializePublicKeyToBase64(decodePublicKey(key.publicKey)));
    }
    for (const root of session.workspace.roots.list()) {
        if (root.name === undefined)
            continue;
        if (root.kind === 'schema')
            hints.schemaNames.set(root.id, root.name);
        if (root.kind === 'group')
            hints.groupNames.set(root.id, root.name);
        if (root.kind === 'database')
            hints.dbNames.set(root.id, root.name);
    }
    return new DumpAliasContext(hints);
}
export function createDumpRenderOptions(session, extra) {
    return Object.assign({ aliasMode: true, aliases: createDumpAliasContext(session) }, extra);
}
